import { Badge, TableColumn } from '@ibsys/kit';
import { Tooltip } from '@/shared/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { C1BotLoadItem } from '@/entities/integrations';

/**
 * Колонки журнала прогрузки диалогов голосового бота.
 */
export const useC1BotLoadColumns = (): TableColumn<C1BotLoadItem>[] => {
  const { t } = useTranslation(['integrations']);

  return useMemo(
    () => [
      {
        accessorKey: 'sessionId',
        header: () => <span>{t('integrations:c1Bot.table.sessionId')}</span>,
        size: 220,
        cell: ({ row }) => <span className="font-mono text-sm">{row.original.sessionId}</span>,
      },
      {
        accessorKey: 'conversationId',
        header: () => <span>{t('integrations:c1Bot.table.conversationId')}</span>,
        size: 130,
        cell: ({ row }) => <span className="text-sm">{row.original.conversationId ?? ''}</span>,
      },
      {
        accessorKey: 'phrasesCount',
        header: () => <span>{t('integrations:c1Bot.table.phrasesCount')}</span>,
        size: 110,
        cell: ({ row }) => <span className="text-sm">{row.original.phrasesCount}</span>,
      },
      {
        accessorKey: 'status',
        header: () => <span>{t('integrations:c1Bot.table.status')}</span>,
        size: 120,
        cell: ({ row }) => {
          const isLoaded = row.original.status === 'loaded';
          const badge = (
            <Badge variant={isLoaded ? 'primary' : 'destructive'}>
              {isLoaded ? t('integrations:c1Bot.table.loaded') : t('integrations:c1Bot.table.error')}
            </Badge>
          );
          // Текст ошибки произвольной длины — показываем подсказкой, а не отдельной колонкой
          return row.original.error ? <Tooltip tooltip={row.original.error}>{badge}</Tooltip> : badge;
        },
      },
      {
        accessorKey: 'updatedAt',
        header: () => <span>{t('integrations:c1Bot.table.updatedAt')}</span>,
        size: 180,
        cell: ({ row }) => (
          <span className="text-sm">
            {row.original.updatedAt ? new Date(row.original.updatedAt).toLocaleString() : ''}
          </span>
        ),
      },
    ],
    [t],
  );
};
